import React from 'react';
import type { ReactNode } from 'react';
import { type AccessOrganization } from '../../../types/access';
import { formatNumber } from '../../../utils/format';
import { RowActions } from '../RowActions/RowActions';
import styles from './OrganizationsTable.module.scss';
import { DataTable, tableStyles } from '../../ui/DataTable/DataTable';

interface OrganizationsTableProps {
    organizations: AccessOrganization[];
    footer?: ReactNode;
    empty?: ReactNode;
    scrollKey?: string | number;
    loading?: boolean;
    isLoading?: boolean;
    loadingText?: string;
    onEdit: (organization: AccessOrganization) => void;
    onDelete: (organization: AccessOrganization) => void;
}

export function OrganizationsTable({
    organizations,
    footer,
    empty,
    scrollKey,
    loading,
    isLoading,
    loadingText,
    onEdit,
    onDelete,
}: OrganizationsTableProps) {
    return (
        <DataTable
            static
            className={styles.table}
            colgroup={
                <colgroup>
                    <col style={{ width: '70%' }} />
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '15%' }} />
                    <col style={{ width: 78 }} />
                </colgroup>
            }
            footer={footer}
            empty={empty}
            scrollKey={scrollKey}
            loading={loading}
            isLoading={isLoading}
            loadingText={loadingText}
        >
            <thead>
                <tr>
                    <th>Наименование</th>
                    <th className={tableStyles.num}>ИНН</th>
                    <th className={tableStyles.num}>Лимит запросов</th>
                    <th className={styles.actions} aria-label="Действия" />
                </tr>
            </thead>

            <tbody>
                {organizations.map((organization) => (
                    <tr key={organization.id}>
                        <td className={styles.name}>{organization.name}</td>

                        <td className={tableStyles.num}>
                            {organization.inn ?? <span className={tableStyles.dash}>—</span>}
                        </td>

                        <td className={tableStyles.num}>
                            {formatNumber(organization.requestsUsed)} из{' '}
                            {formatNumber(organization.requestsLimit)}
                        </td>

                        <td className={styles.actions}>
                            <RowActions
                                onEdit={() => onEdit(organization)}
                                onDelete={() => onDelete(organization)}
                            />
                        </td>
                    </tr>
                ))}
            </tbody>
        </DataTable>
    );
}